import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ItemProdutoEditarComponent } from './item-produto-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: ItemProdutoEditarComponent }
    ])],
    exports: [RouterModule]
})
export class ItemProdutoEditarRoutingModule { }
